import React, { useState, useRef } from "react";
import {
    commonService,
    AppConfigData,
} from "../_services/common.service";
import _Skeleton, { _SkeletonType } from "./_Skeleton";
import _NoDataFound from "./_NoDataFound";
import { useHistory } from "react-router-dom";
import Table from "react-bootstrap/Table";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import { alertService, AlertType } from "../_services/alert.service";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { ModalFooter } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Spinner from "react-bootstrap/Spinner";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";


function ParentTeacherComplain() {
    let data = commonService.getLoginUserData();
    const [txtEndDate, setTxtEndDate] = useState(null);
    const [txtStartDate, setTxtStartDate] = useState(null);
    const history = useHistory();
    const [ComplainList, setComplainList] = useState({ IsData: false, data: [] });
    const [Type, setType] = useState([{ value: "", label: "Select Type" }, { value: "Complain", label: "Complain" }, { value: "Suggestion", label: "Suggestion" }, { value: "Request", label: "Request" }]);
    const [StatusOption, setStatusOption] = useState([{ value: "", label: "Select Status" }, { value: "Open", label: "Open" }, { value: "Completed", label: "Completed" }]);
    const [showAddPopup, setshowAddPopup] = useState(false);
    const [ShowViewDetailsPopup, setShowViewDetailsPopup] = useState(false);

    const [ComplainViewDetails, setComplainViewDetails] = useState({ IsData: false, data: [] });
    const [editorStudentNote, seteditorStudentNote] = useState(() =>
        EditorState.createEmpty()
    );
    const [editorTeacherNote, seteditorTeacherNote] = useState(() =>
        EditorState.createEmpty()
    );
    const [selectedStatus, setSelectedStatus] = useState("Open");


    const [selectedSearchStatus, setSelectedSearchStatus] = useState("");
    const [selectedSearchType, setSelectedSearchType] = useState("");


    const [ComplainData, setComplainData] = useState({
        complainSuggestionID: "00000000-0000-0000-0000-000000000000",
        studentID: "00000000-0000-0000-0000-000000000000",
        createdBy: "00000000-0000-0000-0000-000000000000",
        createdOn: "",
        title: "",
        teacherID: "00000000-0000-0000-0000-000000000000",
        studentNote: "",
        teacherNote: "",
        isActive: "",
        status: "",
        type: "",
        standardID: "00000000-0000-0000-0000-000000000000",
        divisionID: "00000000-0000-0000-0000-000000000000",
        RequestFrom: "Web",
        errors: {
            title: "",
            studentNote: "",
            type: "",
        },
    });

    const [IsListDateLodding, setIsListDateLodding] = useState(false);
    function BindParentTeacherComplainList() {
        setIsListDateLodding(true);
        setComplainList({ IsData: false, data: [] });
        const reqComplain = {
            method: "POST",
            headers: commonService.getHeaders(),
            body: JSON.stringify({
                type: selectedSearchType,
                status: selectedSearchStatus,
                startDate: txtStartDate,
                endDate: txtEndDate,
            }),
        };
        fetch(AppConfigData.APIBasePath + "v1/ParentTeacherComplain/GetParentTeacherComplainByUserID", reqComplain)
            .then((response) => response.json())
            .then(function (json) {
                setIsListDateLodding(false);
                if (json.status_code === 1) {
                    setComplainList({ IsData: true, data: json.data.complainDetails });
                } else if (json.status_code === 0) {
                    setComplainList({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    function fnAddNewComplain() {
        if (validate()) {
            let formData = new FormData();
            formData.append("Title", ComplainData.title);
            formData.append("Type", ComplainData.type);
            formData.append(
                "StudentNote",
                draftToHtml(convertToRaw(editorStudentNote.getCurrentContent()))
            );
            formData.append("RequestFrom", "Web");

            const reqAddComplain = {
                method: "POST",
                enctype: "multipart/form-data",
                processData: false,
                contentType: false,
                headers: commonService.getHeadersFromData(),
                body: formData,
            };

            fetch(AppConfigData.APIBasePath + "v1/ParentTeacherComplain/save", reqAddComplain)
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        setshowAddPopup(false);
                        alertService.alert({
                            type: AlertType.Success,
                            message: json.message,
                        });

                        BindParentTeacherComplainList();
                    } else if (json.status_code === 0) {
                        alertService.alert({
                            type: AlertType.Error,
                            message: json.message,
                        });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                })
        }
    }


    function UpdateComplainByTeacher(ID) {
        let formData = new FormData();
        formData.append("ComplainSuggestionID", ID);
        formData.append("Status", selectedStatus);
        formData.append("TeacherNote", draftToHtml(convertToRaw(editorTeacherNote.getCurrentContent())));
        formData.append("RequestFrom", "Web");

        const reqAddComplain = {
            method: "POST",
            enctype: "multipart/form-data",
            headers: commonService.getHeadersFromData(),
            body: formData,
        };

        fetch(AppConfigData.APIBasePath + "v1/ParentTeacherComplain/UpdateByTeacher", reqAddComplain)
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setShowViewDetailsPopup(false);
                    alertService.alert({
                        type: AlertType.Success,
                        message: json.message,
                    });

                    BindParentTeacherComplainList();
                } else if (json.status_code === 0) {
                    alertService.alert({
                        type: AlertType.Error,
                        message: json.message,
                    });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            })
    }
    function validate() {
        let isValid = true;
        let errors = {};

        if (!ComplainData.title) {
            errors.title = "Title is Required.";
            isValid = false;
        } else {
            errors.title = "";
        }

        if (!ComplainData.type) {
            errors.type = "Type is Required.";
            isValid = false;
        } else {
            errors.type = "";
        }

        setComplainData({
            ...ComplainData,
            ["errors"]: errors,
        });


        return isValid;
    }

    function handleShowAddPopup() {
        setComplainData({
            complainSuggestionID: "00000000-0000-0000-0000-000000000000",
            studentID: "00000000-0000-0000-0000-000000000000",
            createdBy: "00000000-0000-0000-0000-000000000000",
            createdOn: "",
            title: "",
            teacherID: "00000000-0000-0000-0000-000000000000",
            studentNote: "",
            teacherNote: "",
            isActive: "",
            status: "",
            type: "",
            standardID: "00000000-0000-0000-0000-000000000000",
            divisionID: "00000000-0000-0000-0000-000000000000",
            RequestFrom: "Web",
            errors: {
                title: "",
                studentNote: "",
                type: "",
            },
        });
        setshowAddPopup(true);
    }

    function handleShowViewDetailsPopup(ID) {
        if (ID !== "00000000-0000-0000-0000-000000000000" && ID !== "") {
            const reqComplain = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    id: ID,
                    requestFrom: "web",
                })
            };
            fetch(AppConfigData.APIBasePath + "v1/ParentTeacherComplain/GetParentTeacherComplainViewDetails", reqComplain)
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        setComplainViewDetails({ IsData: true, data: json.data.complainDetails });
                        if (data[0].MemberType.toLowerCase() === "teacher") {
                            if (json.data.complainDetails[0].TeacherNote !== "" && json.data.complainDetails[0].TeacherNote !== null) {
                                seteditorTeacherNote(
                                    EditorState.createWithContent(
                                        ContentState.createFromBlockArray(
                                            htmlToDraft(json.data.complainDetails[0].TeacherNote)
                                                .contentBlocks
                                        )
                                    )
                                );
                            }
                            setSelectedStatus(json.data.complainDetails[0].Status);
                        }
                    } else if (json.status_code === 0) {
                        setComplainList({ IsData: true, data: [] });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
            setShowViewDetailsPopup(true);
        }
    }

    function fnDeleteComplain(ID) {
        if (ID !== "00000000-0000-0000-0000-000000000000" && ID !== "") {
            const reqComplain = {
                method: "POST",
                headers: commonService.getHeaders(),
                body: JSON.stringify({
                    id: ID,
                    requestFrom: "Web",
                }),
            };
            fetch(AppConfigData.APIBasePath + "v1/ParentTeacherComplain/deletebyid", reqComplain)
                .then((response) => response.json())
                .then(function (json) {
                    if (json.status_code === 1) {
                        alertService.alert({
                            type: AlertType.Success,
                            message: json.message,
                        });
                        BindParentTeacherComplainList();
                    } else if (json.status_code === 0) {
                        alertService.alert({
                            type: AlertType.Error,
                            message: json.message,
                        });
                    } else if (json.status_code === 2) {
                        localStorage.clear();
                        history.push("/");
                    }
                });
        }
    }

    React.useEffect(() => {
        BindParentTeacherComplainList();
    }, []);

    return (
        <>
            <h1 className="page-header my-4">Parent Teacher Complain</h1>

            <div className="background-theme-color sticky-top homework-searchBar">
                <div className="search-top-section">
                    <div className="row">
                        <div className="col-lg-12 col-xl-7">
                            <div className="align-items-center justify-content-between sticky-top attendence-search-section  first-attendence-section">
                                <div className="row align-items-center m-0 selection-attendence-row">
                                    <div className="col-12 p-0">
                                        <div className="row">
                                            <div className="col-6">
                                                <Select
                                                    placeholder="Select Status"
                                                    options={StatusOption}
                                                    value={StatusOption.find(obj => obj.value === selectedSearchStatus)}
                                                    onChange={(e) => setSelectedSearchStatus(e.value)}
                                                />
                                            </div>
                                            <div className="col-6 pr-0">
                                                <Select
                                                    placeholder={"Select Type"}
                                                    options={Type}
                                                    value={Type.find(obj => obj.value === selectedSearchType)}
                                                    onChange={(e) => setSelectedSearchType(e.value)}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-xl-5 mt-3 mt-xl-0">
                            <div className="search-right-cal d-flex align-items-center">
                                <div className="header-date-area w-100 mr-3">
                                    <div className="d-flex align-items-center">
                                        <label className="from-date">
                                            {commonService.LabelDisplayText("DatepickerFrom")}
                                        </label>
                                        <DatePicker
                                            className="datepicker"
                                            selected={txtStartDate}
                                            dateFormat={data[0].DateFormat_Term}
                                            onChange={(date) => setTxtStartDate(date)}
                                            placeholderText={data[0].DateFormat_Term}
                                        />
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <label className="from-date">
                                            {" "}
                                            {commonService.LabelDisplayText("DatepickerTo")}
                                        </label>
                                        <DatePicker
                                            className="datepicker"
                                            selected={txtEndDate}
                                            minDate={txtStartDate && txtStartDate}
                                            dateFormat={data[0].DateFormat_Term}
                                            onChange={(date) => setTxtEndDate(date)}
                                            placeholderText={data[0].DateFormat_Term}
                                        />
                                    </div>
                                </div>
                                <div className="right-icon-cal d-flex align-items-center">
                                    {IsListDateLodding === false ? (
                                        <div
                                            className="search-icon-img pointer-cursor"
                                            onClick={() => BindParentTeacherComplainList()}
                                        >
                                            <i className="fa-regular fa-magnifying-glass"></i>
                                        </div>
                                    ) : (
                                        <div className="search-icon-img pointer-cursor">
                                            <Spinner animation="border" size="sm" variant="primary" />
                                        </div>
                                    )}
                                    <div
                                        className="plus-btn pointer-cursor ml-3"
                                        onClick={() => handleShowAddPopup()}
                                    >
                                        <i className="fa-regular fa-plus"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!ComplainList.IsData ? (
                <div className="row col-12">
                    <_Skeleton type={_SkeletonType.Table} lineheight={30} />
                </div>
            ) : ComplainList.data.length === 0 ? (
                <div className="col-12">
                    <_NoDataFound fontsize={"150px"} />
                </div>
            ) : (<>
                {(data[0].MemberType.toLowerCase() === "student" || data[0].MemberType.toLowerCase() === "parent") &&
                    (
                        <Table responsive className="fees-payment-table m-0">
                            <thead>
                                <tr>
                                    <th className="w-150px">Title</th>
                                    <th className="text-center w-150px">Teacher Name</th>
                                    <th className="text-center w-150px">Status</th>
                                    <th className="text-center w-150px">Type</th>
                                    <th className="text-center w-150px">Created On</th>
                                    <th className="w-75px">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ComplainList.data.map(
                                    (item, index) =>
                                        <tr key={index}>
                                            <td className="text-left">{item.Title}</td>
                                            <td className="text-center">{item.Name}</td>
                                            <td className="text-center">{item.Status}</td>
                                            <td className="text-center">{item.Type}</td>
                                            <td className="text-center">{commonService.getDateInFormat(item.CreatedOn)}</td>
                                            <td>

                                                <button className="small-btn fees-pay-button mr-3"
                                                    onClick={() => handleShowViewDetailsPopup(item.ComplainSuggestionID)
                                                    }
                                                >
                                                    <i class="fa-regular fa-eye"></i>
                                                </button>

                                                <button className="small-btn fees-pay-button"
                                                    onClick={(() => fnDeleteComplain(item.ComplainSuggestionID))
                                                    }
                                                >
                                                    <i class="fa-regular fa-trash-can"></i>
                                                </button>
                                            </td>
                                        </tr>
                                )}
                            </tbody>
                        </Table>)
                }
                {(data[0].MemberType.toLowerCase() === "teacher") &&
                    (
                        <Table responsive className="fees-payment-table m-0">
                            <thead>
                                <tr>
                                    <th className="w-150px">Title</th>
                                    <th className="text-center w-150px">Student Name</th>
                                    <th className="text-center w-150px">Status</th>
                                    <th className="text-center w-150px">Type</th>
                                    <th className="text-center w-150px">Complain STD</th>
                                    <th className="text-center w-150px">Current STD</th>
                                    <th className="text-center w-150px">CreatedOn</th>
                                    <th className="w-75px">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ComplainList.data.map(
                                    (item, index) =>
                                        <tr key={index}>
                                            <td className="text-left">{item.Title}</td>
                                            <td className="text-center">{item.Name}</td>
                                            <td className="text-center">{item.Status}</td>
                                            <td className="text-center">{item.Type}</td>
                                            <td className="text-center">{item.ComplainStandard} - {item.ComplainDivision}</td>
                                            <td className="text-center">{item.CrrentStandard} - {item.CurrentDivision}</td>
                                            <td className="text-center">{commonService.getDateInFormat(item.CreatedOn)}</td>
                                            <td>
                                                <button className="small-btn fees-pay-button"
                                                    onClick={() => handleShowViewDetailsPopup(item.ComplainSuggestionID)
                                                    }
                                                >
                                                    <i class="fa-regular fa-eye"></i>
                                                </button>
                                            </td>
                                        </tr>
                                )}
                            </tbody>
                        </Table>)
                }
            </>)
            }

            <Modal
                show={ShowViewDetailsPopup}
                backdrop="static"
                keyboard={false}
                onHide={() => setShowViewDetailsPopup(false)}
                className=""
                contentClassName={""}
                dialogClassName={"width-50per"}
            >
                <Modal.Header className="">
                    <h5>Details</h5>
                    <button
                        className="poopup-close-button"
                        onClick={() => setShowViewDetailsPopup(false)}
                    >
                        <i className="icon icon-fi-rr-cross"></i>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <div className="col-sm-10 col-md-10 col-lg-10 col-xl-12 mb-2 mt-2">
                                <div className="col-sm-10 col-md-12 col-lg-12 col-x-12 date-section-area">
                                    <div className="col-1"></div>
                                    {(data[0].MemberType.toLowerCase() === "student" || data[0].MemberType.toLowerCase() === "parent") &&
                                        (
                                            ComplainViewDetails?.data?.map((item) => (
                                                <React.Fragment key={item.ComplainSuggestionID}>
                                                    <p><b>Student Note :</b></p>
                                                    <div
                                                        className="mb-1 mt-1"
                                                        dangerouslySetInnerHTML={{ __html: item.StudentNote }}
                                                    />

                                                    <p className="mt-4"><b>Teacher Note :</b></p>
                                                    <div
                                                        className="mb-1 mt-1"
                                                        dangerouslySetInnerHTML={{ __html: item.TeacherNote }}
                                                    />
                                                </React.Fragment>
                                            ))
                                        )
                                    }

                                    {(data[0].MemberType.toLowerCase() === "teacher") &&
                                        (
                                            ComplainViewDetails.data.map((item, index1) =>
                                                <>
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <b>Title :</b> {item.Title}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-1">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <b>Student Name :</b> {item.StudentName}
                                                        </div>

                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <b>Date :</b> {commonService.getDateInFormat(item.CreatedOn)}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-1">
                                                        <div className="col-md-6 col-lg-6 col-xl-6">
                                                            <b>Current Std : </b>{item.CurrentSTD}
                                                        </div>
                                                        <div className="col-md-6 col-lg-6 col-xl-6">
                                                            <b>Complain Std : </b>{item.ComplainSTD}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-1">
                                                        <div className="col-md-6 col-lg-6 col-xl-6">
                                                            <b>Complain By : </b> {item.CreatedBy}
                                                        </div>
                                                        <div className="col-md-6 col-lg-6 col-xl-6">
                                                            <b>Type : </b>{item.Type}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-1">
                                                        <div className="col-md-12 col-lg-12 col-x-12">
                                                            <b>Student Note : </b> {item.StudentNote}
                                                        </div>
                                                    </div>
                                                    <div className="rich-txt-editor-area mt-3">
                                                        <Editor
                                                            editorState={editorTeacherNote}
                                                            toolbar={AppConfigData.toolbarConfig}
                                                            onEditorStateChange={seteditorTeacherNote}
                                                        />
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 mt-2">
                                                            <div className="row align-items-center">
                                                                <div className="col-6">
                                                                    <ButtonGroup>
                                                                        <Button
                                                                            variant={
                                                                                selectedStatus === "Open"
                                                                                    ? "success"
                                                                                    : "light"
                                                                            }
                                                                            onClick={(e) =>
                                                                                setSelectedStatus("Open")
                                                                            }
                                                                        >
                                                                            Open
                                                                        </Button>
                                                                        <Button
                                                                            variant={
                                                                                selectedStatus === "Completed"
                                                                                    ? "success"
                                                                                    : "light"
                                                                            }
                                                                            onClick={(e) =>
                                                                                setSelectedStatus("Completed")
                                                                            }
                                                                        >
                                                                            Completed
                                                                        </Button>
                                                                    </ButtonGroup>
                                                                </div>

                                                                <div className="col-6">
                                                                    <button
                                                                        className="btn btn-primary float-right"
                                                                        type="button"
                                                                        onClick={() =>
                                                                            UpdateComplainByTeacher(
                                                                                ComplainViewDetails.data[0].ComplainSuggestionID
                                                                            )
                                                                        }>
                                                                        Save
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>)

                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={showAddPopup}
                backdrop="static"
                keyboard={false}
                onHide={() => setshowAddPopup(false)}
                className="modal-theme-color"
                contentClassName={"background-transparent-color"}
                dialogClassName={"modal-full-width"}
                animation={false}
            >
                <Modal.Header className="justify-content-end">
                    <button
                        className="poopup-close-button"
                        onClick={() => setshowAddPopup(false)
                        }
                    >
                        <i className="icon icon-fi-rr-cross"></i>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid p-0 homework-popup-border border-bottom-exam position-relative">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 d-flex align-items-center justify-content-between">
                                    <h1 className="page-header mb-3">
                                        Parent Teacher Complain
                                    </h1>
                                    <button
                                        className="btn btn-primary px-3 pr-4 mb-3"
                                        type="button"
                                        onClick={fnAddNewComplain}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container classwork-popup-detail mt-4">
                        <div className="row">
                            <div className="col-9">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex">
                                            <div className="selectSubject-popup w-100">
                                                <input
                                                    type="text"
                                                    className="title-textbox"
                                                    placeholder="Title"
                                                    defaultValue={ComplainData.title}
                                                    onChange={(e) => setComplainData({
                                                        ...ComplainData,
                                                        ["title"]: e.target.value
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        {ComplainData.errors.title && (<span className="error-message">
                                            {ComplainData.errors.title}
                                        </span>)
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="col-3">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex">
                                            <div className="selectSubject-popup w-100">
                                                <Select placeholder={"Select Type"}
                                                    options={Type}
                                                    onChange={(e) => setComplainData({
                                                        ...ComplainData,
                                                        ["type"]: e.value
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        {ComplainData.errors.type && (<span className="error-message">
                                            {ComplainData.errors.type}
                                        </span>)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="rich-txt-editor-area mt-3">
                                    <Editor
                                        editorState={editorStudentNote}
                                        toolbar={AppConfigData.toolbarConfig}
                                        onEditorStateChange={seteditorStudentNote}
                                    />
                                </div>
                                {ComplainData.errors.studentNote && (<span className="error-message">
                                    {ComplainData.errors.studentNote}
                                </span>)}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ParentTeacherComplain;
